import React, { useEffect, useRef } from "react";
import { Container, Row, Col } from "react-bootstrap";
import Slider from "react-slick";

const groupData = [
  { name: "K. Padole Infrastructures Pvt. Ltd.", logo: "/img/gallery/kpipl-logo.webp" },
  { name: "Siddhivinayak Group", logo: "/img/gallery/logo-full.webp" },
  { name: "Yuva Foundation", logo: "/img/gallery/yuva-foundation.webp" },
  { name: "Yuva GPT", logo: "/img/gallery/group-yuva-gpt.webp" },
  { name: "Yuva Marg", logo: "/img/gallery/yuva-marg.webp" },
  { name: "Yuva FM", logo: "/img/gallery/yuva-fm.webp" },
  { name: "Yuva Hire", logo: "/img/gallery/group-yuva-hire.webp" },
  { name: "Mauli Navnirman", logo: "/img/gallery/mauli-navnirman.webp" },

  // newly added
  { name: "NAREDCO Vidarbha", logo: "/img/gallery/naredco-logo.webp" },
  { name: "BNI", logo: "/img/gallery/bni-logo.webp" },
  { name: "ECPA", logo: "/img/gallery/ecpa.webp" },
  { name: "NDBBFA", logo: "/img/gallery/ndbbfa-logo.webp" },
  { name: "Kunal Padole Group", logo: "/img/gallery/kunal-padole-group-logo.webp" },
  { name: "MaTPO", logo: "/img/gallery/matpo.webp" },
];

// Generic, self-contained dummy logo (no network/image file required).
// Same neutral placeholder for every card until real brand logos are
// added to /img/group/.
const DUMMY_LOGO = `data:image/svg+xml;base64,${btoa(`
  <svg xmlns="http://www.w3.org/2000/svg" width="120" height="120" viewBox="0 0 120 120">
    <rect width="120" height="120" rx="20" fill="#eef0f2"/>
    <g fill="none" stroke="#b6bcc4" stroke-width="4" stroke-linecap="round" stroke-linejoin="round">
      <rect x="34" y="46" width="52" height="42" rx="3"/>
      <path d="M46 46 V34 a4 4 0 0 1 4 -4 h20 a4 4 0 0 1 4 4 v12"/>
      <line x1="46" y1="60" x2="58" y2="60"/>
      <line x1="46" y1="70" x2="58" y2="70"/>
      <line x1="66" y1="60" x2="74" y2="60"/>
      <line x1="66" y1="70" x2="74" y2="70"/>
    </g>
  </svg>
`)}`;

function OurGroupSection() {
  const wrapperRef = useRef(null);

  // Belt-and-suspenders fix: force-set text-align on the actual DOM nodes
  // via JS !important. This cannot be beaten by any external CSS rule,
  // regardless of specificity, load order, or caching — unlike the
  // styled-jsx/CSS approach, which depends on injection timing.
  useEffect(() => {
    const applyCenter = () => {
      const titles = wrapperRef.current?.querySelectorAll(".group-card-title");
      titles?.forEach((el) => {
        el.style.setProperty("text-align", "center", "important");
      });
    };
    applyCenter();
    // Slick clones slides for infinite-loop after its own mount effect —
    // catch those clones too.
    const timer = setTimeout(applyCenter, 100);
    return () => clearTimeout(timer);
  }, []);

  const carouselSettings = {
    dots: false,
    infinite: true,
    slidesToShow: 6,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 0,
    speed: 2000,
    cssEase: "linear",
    pauseOnHover: true,
    arrows: false,
    responsive: [
      { breakpoint: 1200, settings: { slidesToShow: 5 } },
      { breakpoint: 992, settings: { slidesToShow: 4 } },
      { breakpoint: 768, settings: { slidesToShow: 3 } },
      { breakpoint: 480, settings: { slidesToShow: 2 } },
    ],
  };

  return (
    <div className="our-group-area pt-30 pb-30" ref={wrapperRef}>
      <Container fluid className="px-4">
        <Row>
          <Col lg={12}>
            <div className="section-title-area text-center mb-20">
              <h2 className="group-main-title">The Siddhivinayak Group of Companies</h2>
              <div className="title-divider">
                <span></span>
                <span></span>
              </div>
            </div>
          </Col>
        </Row>

        <Row>
          <Col lg={12}>
            <Slider {...carouselSettings} className="group-carousel">
              {groupData.map((item, index) => {
                const isBNI = item.name === "BNI";
                return (
                  <div
                    key={index}
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      textAlign: "center",
                      padding: "0 15px",
                      width: "100%",
                    }}
                  >
                    <div
                      className="group-logo-box"
                      style={{
                        width: "190px",
                        height: "120px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        overflow: "hidden",
                      }}
                    >
                      <img
                        src={item.logo}
                        alt={item.name}
                        width={120}
                        height={80}
                        decoding="async"
                        loading="lazy"
                        style={{
                          maxWidth: isBNI ? "50%" : "80%",
                          maxHeight: isBNI ? "50%" : "80%",
                          width: "auto",
                          height: "auto",
                          objectFit: "contain",
                        }}
                        onError={(e) => {
                          e.currentTarget.onerror = null;
                          e.currentTarget.src = DUMMY_LOGO;
                        }}
                      />
                    </div>
                    <p
                      className="group-card-title"
                      style={{
                        fontSize: "15px",
                        color: "#4a5568",
                        margin: 0,
                        marginTop: "12px",
                        lineHeight: "1.4",
                        textAlign: "center",
                        width: "100%",
                      }}
                    >
                      {item.name}
                    </p>
                  </div>
                );
              })}
            </Slider>
          </Col>
        </Row>
      </Container>

      {/* Scoped, !important-guarded so no global "justify body copy" rule
          elsewhere in the site's CSS can affect this section's card text. */}
      <style jsx global>{`
       .our-group-area .group-card-title {
  text-align: center !important;
  width: 100% !important;
}
      `}</style>
    </div>
  );
}

export default OurGroupSection;